import { sendErrorMetric } from "@expert/cloudwatch-metrics";
import { Container, Stack, Text } from "@mantine/core";
import { useEffect } from "react";

import { useSalesContext } from "../../../../sales-context/SalesContext";
import { IneligibleIcon, LoadingAnimation } from "../../../product-sale-flow/components/Icons";
import { useEligibility } from "../../hooks/useEligibility";
import { useProductOfferPolling } from "../../hooks/useProductOfferPolling";
import { usePushDiscoveryEngagementToTimeline } from "../../hooks/usePushDiscoveryEngagementToTimeline";
import { useQuerySelectedProductOffer } from "../../hooks/useQuerySelectedProductOffer";
import classes from "./CustomerOffers.module.css";
import { CustomerOffersLoaded } from "./CustomerOffersLoaded";

export function CustomerOffers() {
    const { logger, taskType, startedTimestamp } = useSalesContext();

    useQuerySelectedProductOffer();
    useProductOfferPolling();
    usePushDiscoveryEngagementToTimeline();

    const { error, isError, isLoading } = useEligibility();

    useEffect(() => {
        if (isError) {
            logger.warn({ error }, "Error checking eligibility");
            void sendErrorMetric("EligibilityError", { eventSource: "Eligibility-FE" });
        }
    }, [isError, error, logger]);

    if (isError) {
        return (
            <Stack align="center" data-testid="failure" mt="sm">
                <Container>{IneligibleIcon}</Container>
                <Text className={classes.statusBodyHeader}>We had an issue checking eligibility.</Text>
                <Text className={classes.statusBodyText} data-testid="sale-view-status-body">
                    Try refreshing the page.
                </Text>
            </Stack>
        );
    }

    if (isLoading) {
        return (
            <Stack align="center" mt="sm">
                <Text size="sm">Confirming customer information...</Text>
                <Container maw="160px">
                    <LoadingAnimation />
                </Container>
            </Stack>
        );
    }

    return <CustomerOffersLoaded startedTimestamp={startedTimestamp} isChat={taskType.isChat} />;
}
